import AirModal from "./AirModal"

export default  AirModal;



// WEBPACK FOOTER //
// ./src/common/components/AirModal/index.js